export default __webpack_public_path__ + "static/media/fangzhicuzhong.666c4c2c.png";